module.exports = __webpack_public_path__ + "img/porsche-svg.e14a6917.svg";